import React, { useEffect, useState } from "react";
import "./Blogdetail.css";
import Hero from "../Components/Banner";
import banner from '../Assets/contact-bg.jpg'
import { useNavigate } from "react-router-dom";

const Blogdetail = () => {
  const [blogData, setBlogData] = useState({});
  const [blogSections, setBlogSections] = useState([]);

useEffect(() => {
  window.scrollTo(0, 0); 

  const id = new URLSearchParams(window.location.search).get("id");
  console.log("Fetched blog id from URL:", id);

  fetch(`https://blog.novaedubridge.com/api/get-blog-details.php?id=${id}`)
    .then((res) => res.json())
    .then((data) => {
      console.log("Fetched blog data:", data);
      if (data.blog) {
        setBlogData(data.blog);
      }
      if (data.sections) {
        setBlogSections(data.sections);
      }
    })
    .catch((err) => console.error("Failed to fetch blog:", err));
}, []);

   const navigate = useNavigate();
  const handleServicesClick = () => {
     navigate('/Contact');
  };


  return (
    <div>

         <Hero
        title={<><span className="highlight">Our </span><br />Blogs</>}
        bgImage={banner}
         onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
      <div className="blog-details-wrapper container bodybg">
  <main className="blog-container">
    {/* Blog Title, Date, Content & Image */}
    <div className="blog-main-section">
      <div className="blog-main-text">
        <h1>{blogData.title || ""}</h1>
        {blogData.published_date && (
          <p className="published-date">
            Published on:{" "}
            {new Date(blogData.published_date).toLocaleDateString("en-IN", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        )}
        <p>{blogData.content || ""}</p>
      </div>

      <div className="blog-main-image">
        {blogSections[0]?.image_path ? (
          <img
  src={blogSections[0].image_path}
  alt={blogData.title || "Blog main image"}
/>
        ) : (
          <p>No image</p>
        )}
      </div>
    </div>

    {/* Dynamic Blog Sections */}
    {blogSections.length > 0 ? (
      blogSections.map((section, index) => (
        <div className="blog-details-section" key={index}>
          <h2>{section.title || ``}</h2>
          {/* Removed blog-image-container */}
          <p className="blog-section-content">{section.content}</p>
        </div>
      ))
    ) : (
      <p>No sections found.</p>
    )}
  </main>
  
</div>
    </div>
    

  );
};

export default Blogdetail;
